<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-verification`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_7e289398d9__clip0_10090_51295)"><path d="M6.82225 0.985583C7.47239 0.335447 8.52748 0.335622 9.17772 0.985583L15.0146 6.8225C15.6649 7.47272 15.6649 8.52774 15.0146 9.17797L9.17772 15.0149C8.5275 15.6651 7.47248 15.6651 6.82225 15.0149L0.985339 9.17797C0.335377 8.52772 0.335204 7.47263 0.985339 6.8225L6.82225 0.985583ZM8.23729 1.92601C8.10644 1.79545 7.89342 1.79528 7.76268 1.92601L1.92577 7.76293C1.79503 7.89367 1.7952 8.10669 1.92577 8.23754L7.76268 14.0745C7.89351 14.2053 8.10647 14.2053 8.23729 14.0745L14.0742 8.23754C14.205 8.10671 14.205 7.89375 14.0742 7.76293L8.23729 1.92601ZM7.63475 5.19359C7.89278 5.0235 8.24357 5.05157 8.47069 5.27855L10.7217 7.53051C10.9812 7.79021 10.9813 8.21128 10.7217 8.47093L8.47069 10.7219C8.21103 10.9816 7.78997 10.9815 7.53026 10.7219L5.27831 8.47093C5.01888 8.21135 5.01903 7.79018 5.27831 7.53051L7.53026 5.27855L7.63475 5.19359ZM6.68944 8.00023L7.99999 9.31078L9.31053 8.00023L7.99999 6.68968L6.68944 8.00023Z"/></g><defs><clipPath id="svg_7e289398d9__clip0_10090_51295"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLineVerification',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
